import Fade from 'react-reveal/Fade';
import React, { Component } from 'react';
import { Grid, Col, Row, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Home.css';
import ModalVideo from '../common/ModalVideo';
import DistilleryManagementDemo from '../common/DistilleryManagementDemo';
import ConsumerExperience from '../common/ConsumerExperience';
import ConsumerIntelligence from '../common/ConsumerIntelligence';
import Tweets from '../common/Tweets';
import Press from '../common/Press';
import config from '../../constant/config';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      showVideoPlayer: false,
    };
    this.onClosePlayer = this.onClosePlayer.bind(this);
  }
  componentDidMount() {
    this.scrollTo();
  }

  componentDidUpdate() {
    this.scrollTo();
  }

  onClickPlayer(e) {
    e.preventDefault();
    this.setState({ showVideoPlayer: true });
  }

  onClosePlayer() {
    this.setState({ showVideoPlayer: false });
  }

  onClickSubmit(e) {
    e.preventDefault();
    this.validateForm();
  }

  scrollTo() {
    const { hash } = this.props.location;
    if (hash === '#consumerexperience') {
      setTimeout(
        () =>
          this.consumerExperience.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          }),
        0,
      );
    }

    if (hash === '#consumerintelligence') {
      setTimeout(
        () =>
          this.consumerIntelligence.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          }),
        0,
      );
    }

    if (hash === '#distillerymanagementplatform') {
      setTimeout(
        () =>
          this.managementDemo.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          }),
        0,
      );
    }
  }

  isEmailValid(email) {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  validateForm() {
    const { email } = this.state;
    this.setState({
      validEmail: this.isEmailValid(email),
    });
  }

  render() {
    return (
      <div className="home">
        <div className="interest-panel">
          <Grid>
            <Row className="overview">
              <Col md={6} sm={12}>
                <div className="overview-copy">
                  <h1 className="header-font">
                    A new take on distillery management software
                  </h1>
                  <h3 className="overview-description">
                    Distilled ID enables your distillery to connect the story of
                    your brand to the customers who love it. Our product
                    provides the means to track your unique spirit from grain to
                    bottle and beyond and share your tale with the world.
                  </h3>
                  <div className="register-interest">
                    <form
                      className="form"
                      action="https://distilledid.us19.list-manage.com/subscribe/post?u=6e0c08acecd6f451122ecc6f7&amp;id=66bf4fdc88"
                      method="post"
                    >
                      <Link to="/about">
                        <Button
                          bsClass="get-in-touch-button"
                          className="blue-link-arrow"
                        >
                          {' '}
                          <div className="get-in-touch-text">
                            Get in touch to schedule a demo
                          </div>{' '}
                        </Button>
                      </Link>
                    </form>
                  </div>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div className="video-wrapper">
                  <div
                    role="presentation"
                    className="play-button"
                    onClick={e => this.onClickPlayer(e)}
                  />
                  <ModalVideo
                    show={this.state.showVideoPlayer}
                    handleClose={this.onClosePlayer}
                    url={config.landingPageVideoUrl}
                    controls={false}
                    height="70vh"
                    width="auto"
                  />
                </div>
              </Col>
            </Row>
            <Row className="features-container">
              <ol className="row feature-list feature-links">
                <Fade delay={300}>
                  <Col md={4} className="feature-box">
                    <li>
                      <a
                        className="feature-icon operations"
                        onClick={() => {
                          this.managementDemo.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest',
                          });
                        }}
                      >
                        <h2 className="link-arrow">
                          Manage distillery operations
                        </h2>
                        <p>
                          Full distillery and cask management system using the
                          latest technology incorporating blockchain.
                        </p>
                      </a>
                    </li>
                  </Col>
                </Fade>
                <Fade delay={600}>
                  <Col md={4} className="feature-box">
                    <li>
                      <a
                        className="feature-icon unique-storybook"
                        onClick={() => {
                          this.consumerExperience.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest',
                          });
                        }}
                      >
                        <h2 className="link-arrow">
                          Connect with your consumers
                        </h2>
                        <p>
                          Create a unique Storybook, track the product, prove
                          provenance and issue a unique certificate of
                          authenticity.
                        </p>
                      </a>
                    </li>
                  </Col>
                </Fade>
                <Fade delay={900}>
                  <Col md={4} className="feature-box">
                    <li>
                      <a
                        className="feature-icon intelligence"
                        onClick={() => {
                          this.consumerIntelligence.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest',
                          });
                        }}
                      >
                        <h2 className="link-arrow">Explore and understand</h2>
                        <p>
                          Get access to Product & Consumer Analytics at an
                          individual bottle level. Identify new markets and spot
                          parallel trading.
                        </p>
                      </a>
                    </li>
                  </Col>
                </Fade>
              </ol>
            </Row>
            <Row>
              <Fade delay={1200}>
                <section className="block-clients">
                  <div className="wrapper">
                    <ul className="companies">
                      <li>
                        <div className="ab-logo logo" />
                      </li>
                      <li>
                        <div className="wg-logo logo" />
                      </li>
                      <li>
                        <div className="blackwater-logo logo" />
                      </li>
                      <li>
                        <div className="icb-logo logo" />
                      </li>
                    </ul>
                  </div>
                </section>
              </Fade>
            </Row>
          </Grid>
        </div>
        <div
          ref={(r) => {
            this.managementDemo = r;
          }}
        >
          <DistilleryManagementDemo />
        </div>
        <Fade>
          <div
            ref={(r) => {
              this.consumerExperience = r;
            }}
          >
            <ConsumerExperience />
          </div>
        </Fade>
        <Fade>
          <div
            ref={(r) => {
              this.consumerIntelligence = r;
            }}
          >
            <ConsumerIntelligence />
          </div>
        </Fade>
        <Press />
        <Tweets />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/views/Home.js